var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 1.55 0.4 2 0.888889 2H15.1111C15.6 2 16 1.55 16 1C16 0.45 15.6 0 15.1111 0H0.888889C0.4 0 0 0.45 0 1ZM7.11111 12H8.88889C9.37778 12 9.77778 11.55 9.77778 11C9.77778 10.45 9.37778 10 8.88889 10H7.11111C6.62222 10 6.22222 10.45 6.22222 11C6.22222 11.55 6.62222 12 7.11111 12ZM12.4444 7H3.55556C3.06667 7 2.66667 6.55 2.66667 6C2.66667 5.45 3.06667 5 3.55556 5H12.4444C12.9333 5 13.3333 5.45 13.3333 6C13.3333 6.55 12.9333 7 12.4444 7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.aabd08db54ae057a068a36d51f67f2f0.svg";
export { ForwardRef as ReactComponent };